import React from 'react'
import SubChildLayout from '../../components/SubChildLayout/SubChildLayout';
import CustomDataTable from '../../components/CustomDataTable/CustomDataTable';
import { useOutlet } from 'react-router-dom';
import { ENDPOINT } from '../../services/endPoints';

const NursesList = () => {
    const outlet = useOutlet();
    const excludedKeys = ['id', 'password', "nurses_national_id","nurses_sex","nurses_dob","city","password","nurses_email_id","nurses_contact","section","isActivated",
     'updatedAt', 'deletedAt', "createdAt","year","nurses_role","nurses_last_name"];

     const compareValue = ["nurses_id", "nurses_first_name" ,  "facility_name", "facility_type",  "nurses_region","status","facility_code"];
 
     const customKeyName = {
    nurses_id: "ID",
    nurses_first_name: "First Name",
    facility_name: "Facility Name",
    facility_type: "Type",
    nurses_region: "Region",
    status: "Status",
    facility_code: "Facility Code",
  };

  const customWidth = {
    nurses_id: "0px",
    nurses_first_name: "200px",
    facility_name: "400px",
    facility_type: "100px",
    nurses_region: "50px",
    facility_code: "120px",
    status: "100px",
  }


    return (
        outlet || (
          <>
            <SubChildLayout path={"/nurses-list/add"} buttonName={"Add Nurse"}>
              <CustomDataTable
                tableTitle={"List of Nurses"}
                endPoint={ENDPOINT.NURSE}
                filterKey={"nurses_first_name"}
                excludedKeys={excludedKeys}
                compareValue={compareValue}
                customKeyName={customKeyName}
                customWidth={customWidth}
              />
            </SubChildLayout>
          </>
        )
      );
}

export default NursesList